import React from 'react';
import PropTypes from 'prop-types';
import { HttpClient } from '@wix/http-client';
import getCurrentLocale, { DEFAULT_LOCALE } from '../utils/current-locale';
import translationsService from './translations-service';

class I18nProvider extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);

    this.httpClient = new HttpClient();
    this.state = {
      isReady: false,
    };
  }

  componentDidMount() {
    this.loadTranslations();
  }

  loadTranslations() {
    this.fetchTranslationsByLocale(getCurrentLocale()).then(
      (translations) => this.setTranslations(translations),
      () => {
        return this.fetchTranslationsByLocale(DEFAULT_LOCALE).then(
          (translations) => this.setTranslations(translations),
        );
      },
    );
  }

  setTranslations(translations) {
    translationsService.set(translations);
    this.setState({ isReady: true });
  }

  fetchTranslationsByLocale(locale) {
    return this.httpClient
      .get(
        `${window.__STATICS_BASE_URL__}/assets/locale/messages_${locale}.json`,
      )
      .then((response) => response.data);
  }

  render() {
    return this.state.isReady ? this.props.children : null;
  }
}

export default I18nProvider;
